/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @next/next/no-img-element */
import React, { useContext } from "react";
import RockstarFooter from "components/RockstarFooter";
import RockstarHeader from "components/RockstarHeader";
import { endpoints } from "config";
import HeadTagsRenderer from "components/HeadTagsRenderer";
import { WpYoastHead } from "types/wp-yoast-head";
import { LogContext } from "context/log";
import TopCtaBanner from "components/TopCtaBanner";
import { GetServerSideProps } from "next";
import { PAGE_TYPE_ENUM } from "@pepdirect/shared/types";
import { generatePageId } from "@pepdirect/helpers/analyticsLogger";

export const getServerSideProps: GetServerSideProps = async (context) => {
  return {
    props: {},
  };
};

export default function FindYourFlavorPage(): JSX.Element {
  const { useLogPageView } = useContext(LogContext);

  const seoTags: WpYoastHead = {
    title: "Find your flavor - Rockstar Energy",
    canonical: `${endpoints.web}/find-your-flavor/`,
    og_locale: "en_US",
    og_type: "website",
    og_title: "Find your flavor - Rockstar Energy",
    og_url: `${endpoints.web}/find-your-flavor/`,
    og_site_name: "Rockstar Energy",
  };

  useLogPageView({
    pageType: PAGE_TYPE_ENUM.other,
    pageCategory: undefined,
    pageTitle: seoTags.title || "",
    id: generatePageId("find-your-flavor"),
  });

  const iframeStyle = {
    width: "100%",
    minHeight: "600px",
  };

  return (
    <>
      <HeadTagsRenderer yoastJson={seoTags} />

      <div id="page" className="site">
        <a className="skip-link screen-reader-text" href="#content">
          Skip to content
        </a>

        <div className="site-header-block">
          <TopCtaBanner />
          <RockstarHeader />

          <div id="content" className="site-content">
            <div id="primary" className="content-area">
              <main id="main" className="site-main" role="main">
                <div style={{ maxWidth: "1700px", margin: "auto" }}>
                  <iframe
                    className="jebbit-iframe"
                    src="https://quiz.rockstarenergy.com/9jl9u2r1?L=Full+Page&deferred=true"
                    frameBorder="0"
                    onLoad={() => {
                      function embedJebbit(t: any) {
                        function e(t: any) {
                          const e =
                            "attach" === t
                              ? window.addEventListener
                              : window.removeEventListener;
                          e("DOMContentLoaded", i, !1);
                          e("load", i, !1);
                          e("scroll", i, !1);
                          e("resize", i, !1);
                        }
                        const n = document.querySelector(t);
                        function i() {
                          (function (t: any) {
                            const e = t.getBoundingClientRect(),
                              n = t.clientHeight / 2,
                              i = t.clientWidth / 2;
                            return (
                              e.top >= 0 &&
                              e.left >= 0 &&
                              e.top <=
                                (window.innerHeight ||
                                  document.documentElement.clientHeight) -
                                  n &&
                              e.left <=
                                (window.innerWidth ||
                                  document.documentElement.clientWidth) -
                                  i
                            );
                          })(n) &&
                            n?.contentWindow?.postMessage(
                              "startJebbitCampaign",
                              "*"
                            );
                        }
                        window.addEventListener(
                          "message",
                          function (t: any) {
                            t &&
                              ("jebbitSessionCreated" === t.data
                                ? e("remove")
                                : "jebbitCampaignLoaded" === t.data
                                ? i()
                                : t.data &&
                                  "redirect" === t.data.action &&
                                  t.data.options &&
                                  t.data.options.link &&
                                  (window.location.href = t.data.options.link));
                          },
                          !1
                        );
                        e("attach");
                      }
                      embedJebbit(".jebbit-iframe");
                    }}
                    style={iframeStyle}
                  ></iframe>
                </div>
              </main>
            </div>
          </div>

          <RockstarFooter />
        </div>
      </div>
    </>
  );
}
